<div class="option-group" [class.hidden]="hidden">
  <span class="group-label">{{ label }}</span>
  <div class="group-options">
    <ng-content></ng-content>
  </div>
</div>
